import { Slide } from '@mui/material';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import * as S from './side-panel.styles';

export interface ISidePanelProps {
    className?: string;
    children?: React.ReactElement | (boolean | React.ReactElement)[];
}

const MIN_WIDTH = 300;
const MAX_WIDTH = 800;
const DEFAULT_WIDTH = 500;

// FIXME: force scroll to bottom of S.Scrollable
export const SidePanel: React.FunctionComponent<ISidePanelProps> = (props: ISidePanelProps): React.ReactElement => {
    const { className, children } = props;
    const [width, setWidth] = useState(DEFAULT_WIDTH);
    const [isResizing, setIsResizing] = useState(false);
    const startXRef = useRef(0);
    const startWidthRef = useRef(DEFAULT_WIDTH);

    const handleMouseDown = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        setIsResizing(true);
        startXRef.current = e.clientX;
        startWidthRef.current = width;
    }, [width]);

    useEffect(() => {
        if (!isResizing) return;

        const handleMouseMove = (e: MouseEvent) => {
            const deltaX = startXRef.current - e.clientX; // Inverted because panel is on the right
            const newWidth = Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, startWidthRef.current + deltaX));
            setWidth(newWidth);
        };

        const handleMouseUp = () => {
            setIsResizing(false);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing]);

    return (
        <Slide in={true} direction="left">
            <S.SidePanel className={className} width={width}>
                <S.ResizeHandle onMouseDown={handleMouseDown} isResizing={isResizing} />
                {children}
            </S.SidePanel>
        </Slide>
    );
};
